import { de, enUS, es, fr, frCA, it, ja, ko, pt, zhCN } from 'date-fns/locale';
import { pipe } from 'fp-ts/function';
import * as Str from 'fp-ts/string';
var locales = {
  de: de,
  en: enUS,
  es: es,
  fr: fr,
  'fr-CA': frCA,
  it: it,
  ja: ja,
  ko: ko,
  pt: pt,
  zh: zhCN
};

var isTranslationLanguage = function isTranslationLanguage(lang) {
  return Object.keys(locales).includes(lang);
};

export var convertToSupportedLang = function convertToSupportedLang(lang) {
  return isTranslationLanguage(lang) ? lang : lang.lastIndexOf('-') === -1 ? 'en' : pipe(lang.lastIndexOf('-'), function (index) {
    return Str.slice(0, index)(lang);
  }, convertToSupportedLang);
};
export var getLocale = function getLocale(lang) {
  return lang ? pipe(lang, convertToSupportedLang, function (locale) {
    return locales[locale];
  }) : undefined;
};